import { useCallback, useLayoutEffect } from 'react';
import { useAppDispatch } from 'src/AppContext';
import { useFormInputEmail } from 'src/components/FormInput';
import { useRecaptcha } from 'src/components/Recaptcha';
import Button from 'src/components/Button';
import { userEmailPasswordChange } from 'src/services/api';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { PASSWORD_RESET_EMAIL_VALIDATE_ERROR } from 'src/constants/validate';
import { useModal } from 'src/ModalContext';
import { get } from 'lodash';

export default function PasswordReset(): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { showModal } = useModal();
  const history = useCustomHistory();
  const emailInput = useFormInputEmail({
    errors: PASSWORD_RESET_EMAIL_VALIDATE_ERROR,
  });
  const { token, reset, Recaptcha } = useRecaptcha();

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      userEmailPasswordChange({
        email: emailInput.value.trim(),
        reCaptchaResponse: e.target.reCaptchaResponse.value,
      })
        .then((res) => {
          history.push('/password/send', {
            email: res.email,
          });
        })
        .catch((e) => {
          reset();
          const code = get(e, 'response.data.code');
          let message = e.message;
          switch (code) {
            case 'USER_NOT_FOUND':
              message = t('password/reset/user_not_found_error');
              break;
            case 'NOT_VERIFIED_USER':
              message = t('password/reset/not_verified_user_error');
              break;
          }

          showModal({
            message,
            success: () => {
              return;
            },
          });
        });
    },
    [history, emailInput.value],
  );

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'back' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'hidden' });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  return (
    <>
      <form onSubmit={onSubmit}>
        <div className="container mt-6">
          <h1 className="N_20_R">{t('password/reset/title')}</h1>
          <div className="mt-7">{emailInput.CustomFormInput}</div>
          <div className="mt-4">
            <input type="hidden" name="reCaptchaResponse" value={token}></input>
            {Recaptcha}
          </div>
          <div className="mt-6">
            <Button title={t('password/reset/send_button')} type="submit" disabled={!(emailInput.isValid && token.length > 0)}></Button>
          </div>
        </div>
        <ul className="container mt-10 py-6 N_12_R text-brown-grey bg-pale-grey list-disc">
          <li>{t('password/reset/disclaimer_1')}</li>
          <li>{t('password/reset/disclaimer_2')}</li>
        </ul>
      </form>
    </>
  );
}
